const type = 'SET_CUSTOMER_AVATAR';

const setCustomerAvatar = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerAvatar;
